import { Button, useDisclosure } from '@chakra-ui/react'
import { toast } from 'react-toastify'

import { ConfirmationDialog } from '@/components/shared/displayers/ConfirmationDialog'
import { Can } from '@/features/sessao/providers/auth-context'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { CallTechUserReport } from '@/services/backend/config/entities'
import { Repository } from '@/services/repository'

import { useGetCallDetails } from '../../hooks/get-callDetails'
import { useGetCallProducts } from '../../hooks/get-callProducts'

interface Props {
  callId: number
  techUserId: string
  onSuccess: (data: CallTechUserReport) => void
}

export default function Component({ callId, techUserId, onSuccess }: Props) {
  const confirmation = useDisclosure()
  const { user } = useAuthStore()
  // const queryClient = useQueryClient();
  const { invalidateCallDetails } = useGetCallDetails(callId)
  const { invalidateCallProducts } = useGetCallProducts(callId)

  if (!user) return null
  if (user.id !== techUserId) return null

  const createHandler = async () => {
    try {
      const res = await Repository.Entity.CallTech.Create({
        callId,
        techUserId: user.id,
      })
      toast.success('Atendimento iniciado com sucesso')
      onSuccess(res)
      invalidateCallDetails()
      invalidateCallProducts()
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <Can asDefault I="create" a="CallReport" passThrough>
      {(allowed) => (
        <>
          <Button
            isDisabled={!allowed}
            colorScheme="primary"
            onClick={confirmation.onOpen}
          >
            Iniciar atendimento
          </Button>

          <ConfirmationDialog {...confirmation} onConfirm={createHandler}>
            Confirma o início do atendimento?
          </ConfirmationDialog>
        </>
      )}
    </Can>
  )
}
